"use strict";
//
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultArray = void 0;
const core_1 = require("@hcengineering/core");
class ResultArray {
    hierarchy;
    docs;
    loadedModifiedOn = new Map();
    clones = new Map();
    get length() {
        return this.docs.size;
    }
    constructor(docs, hierarchy) {
        this.hierarchy = hierarchy;
        this.docs = new Map(docs.map((it) => [it._id, it]));
        for (const doc of docs) {
            this.loadedModifiedOn.set(doc._id, doc.modifiedOn);
        }
    }
    isLoadedAtModifiedOn(_id, modifiedOn) {
        return this.loadedModifiedOn.get(_id) === modifiedOn;
    }
    clearLoadedModifiedOn(_id) {
        this.loadedModifiedOn.delete(_id);
    }
    clean() {
        this.clones.clear();
    }
    getDocs() {
        return Array.from(this.docs.values());
    }
    findDoc(_id) {
        return this.docs.get(_id);
    }
    getClone() {
        return this.hierarchy.clone(this.getDocs());
    }
    getResult(id) {
        // Lets form a new list based on clones we have already.
        const info = this.clones.get(id);
        if (info === undefined) {
            const docs = this.getClone();
            this.clones.set(id, new Map(docs.map((it) => [it._id, it])));
            return docs;
        }
        else {
            return Array.from(info.values());
        }
    }
    delete(_id) {
        this.loadedModifiedOn.delete(_id);
        const doc = this.docs.get(_id);
        this.docs.delete(_id);
        for (const [, v] of this.clones.entries()) {
            v.delete(_id);
        }
        return doc;
    }
    updateDoc(doc, mainClone = true) {
        this.docs.set(doc._id, mainClone ? this.hierarchy.clone(doc) : doc);
        for (const [, v] of this.clones.entries()) {
            v.set(doc._id, this.hierarchy.clone(doc));
        }
    }
    push(doc) {
        this.docs.set(doc._id, this.hierarchy.clone(doc));
        for (const [, v] of this.clones.entries()) {
            v.set(doc._id, this.hierarchy.clone(doc));
        }
        // this.changes.add(doc._id)
    }
    pop() {
        const lastElement = Array.from(this.docs)[this.docs.size - 1];
        if (lastElement !== undefined) {
            this.docs.delete(lastElement[0]);
            for (const [, v] of this.clones.entries()) {
                v.delete(lastElement[0]);
            }
            return lastElement[1];
        }
        return undefined;
    }
    sort(_class, sort, hierarchy, memdb) {
        const docs = Array.from(this.docs.values());
        (0, core_1.resultSort)(docs, sort, _class, hierarchy, memdb);
        this.docs = new Map(docs.map((it) => [it._id, it]));
        for (const [k, v] of this.clones.entries()) {
            this.clones.set(k, new Map(docs.map((it) => [it._id, v.get(it._id) ?? this.hierarchy.clone(it)])));
        }
    }
}
exports.ResultArray = ResultArray;
//# sourceMappingURL=results.js.map